import React from 'react';
import { api } from '../../../api';
import { PerformanceTabContentProps } from '../ChaptersPerformanceTabContent/ChaptersPerformanceTabContent';
import { PerformanceTabContent } from '../PerformanceTabContent/PerformanceTabContent';
import { FetchParams, PerformanceTabs } from '../performanceUtils';
import { nodeColumns, nodeHeaders } from '../tableUtils/columns/nodesColumns';

export function NodesPerformanceTabContent(props: PerformanceTabContentProps) {
  const { pageSize } = props;

  const fetchPerformanceData = async (
    params: FetchParams,
    signal: AbortSignal,
  ) => {
    const response = await api.get(
      '/v2/analytics/performance/nodes',
      { params, signal },
    );
    return response.data;
  };

  return (
    <PerformanceTabContent
      tabTitle={PerformanceTabs.Nodes}
      csvHeaders={nodeHeaders}
      columns={nodeColumns}
      getData={fetchPerformanceData}
      pageSize={pageSize}
    />
  );
}
